import { Action } from "@ngrx/store";
import { IServerResponse } from "app/interface";
import {
    COMMODITY_LIST, GET_COMMODITY_LIST, SEARCH_COMMODITY_BY_ID, COMMODITY_BY_ID,
    ADD_COMMODITY, ADD_COMMODITY_RESP, UPDATE_COMMODITY, UPDATE_COMMODITY_RESP,
    DELETE_COMMODITY, DELETE_COMMODITY_RESP, COMMODITIES_LINKBY_CONTRACT_ID_RESP, GET_COMMODITIES_LINKBY_CONTRACT_ID,
    SEARCH_COMMODITY_BY_FIELD, GET_COST_TRACKER_CONTRACTS_BY_COMMODITY_ID, COST_TRACKER_CONTRACTS_BY_COMMODITY_ID_RESPONSE,
    COMMODITY_BY_FIELD_LIST
} from "./actionTypes";

export class GetCommodityList implements Action {
    readonly type = GET_COMMODITY_LIST;
}

export class CommodityList implements Action {
    readonly type = COMMODITY_LIST;
    readonly payload = []
    constructor(kpiList: Array<any>) {
        this.payload = kpiList;
    }
}

export class SearchCommodityById implements Action {
    readonly type = SEARCH_COMMODITY_BY_ID;
    readonly payload: string = null;
    constructor(id) {
        this.payload = id
    }
}

export class CommodityById implements Action {
    readonly type = COMMODITY_BY_ID;
    readonly payload = null;
    constructor(data) {
        this.payload = data
    }
}

export class SearchCommodityByField implements Action {
    readonly type = SEARCH_COMMODITY_BY_FIELD;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class CommodityByFieldList implements Action {
    readonly type = COMMODITY_BY_FIELD_LIST;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}
export class AddCommodity implements Action {
    readonly type = ADD_COMMODITY;
    readonly payload: any = null;
    constructor(data) {
        this.payload = data;
    }
}

export class AddCommodityResp implements Action {
    readonly type = ADD_COMMODITY_RESP;
    readonly payload: IServerResponse;
    constructor(resp) {
        this.payload = resp;
    }
}

export class UpdateCommodity implements Action {
    readonly type = UPDATE_COMMODITY;
    readonly payload: any = null;
    constructor(data) {
        this.payload = data;
    }
}

export class UpdateCommodityResp implements Action {
    readonly type = UPDATE_COMMODITY_RESP;
    readonly payload: IServerResponse;
    constructor(resp) {
        this.payload = resp;
    }
}

export class DeleteCommodity implements Action {
    readonly type = DELETE_COMMODITY;
    readonly payload: any = null;
    constructor(data) {
        this.payload = data;
    }
}

export class DeleteCommodityResp implements Action {
    readonly type = DELETE_COMMODITY_RESP;
    readonly payload: IServerResponse;
    constructor(resp) {
        this.payload = resp;
    }
}

export class GetCommodityLinkByContractId implements Action {
    readonly type = GET_COMMODITIES_LINKBY_CONTRACT_ID;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class CommoditiesLinkByContractIdResp implements Action {
    readonly type = COMMODITIES_LINKBY_CONTRACT_ID_RESP;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class GetCostTrackerContractsByCommodityId implements Action {
    readonly type = GET_COST_TRACKER_CONTRACTS_BY_COMMODITY_ID;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class CostTrackerContractsByCommodityIdResponse implements Action {
    readonly type = COST_TRACKER_CONTRACTS_BY_COMMODITY_ID_RESPONSE;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}


export type Actions = GetCommodityList | CommodityList | SearchCommodityById | CommodityById | AddCommodity | AddCommodityResp
    | UpdateCommodity | UpdateCommodityResp | DeleteCommodity | DeleteCommodityResp | GetCommodityLinkByContractId
    | CommoditiesLinkByContractIdResp | SearchCommodityByField | CommodityByFieldList | GetCostTrackerContractsByCommodityId | CostTrackerContractsByCommodityIdResponse;
